import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import IsCustomer from "../../HOC/IsCustomer";
import Loader from "../../components/Loader/Loader";
import { orderService } from "../../services/order.service";
import { cleaningRequestsActions } from "../../store/slices/cleaningRequestsSlice";
import { feedbackCustomerActions } from "../../store/slices/feedbackCustomerSlice";
import { offerActions } from "../../store/slices/offerSlice";
import ConfirmOrderPage from "../ConfirmOrderPage/ConfirmOrderPage";
import DetailsOrderPage from "../DetailsOrderPage/DetailsOrderPage";
import SearchCleanerPage from "../SearchCleanerPage/SearchCleanerPage";

const TriangleStepperPagesContainer = () => {
    const {pathname, state} = useLocation();

    const [id, setId] = useState(null);
    const [currentStep, setCurrentStep] = useState(state?.step || 'step1');
    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = useState([]);
    const [isOrder, setIsOrder] = useState(false);

    const dispatch = useDispatch();
    const {order} = useSelector(state => state.cleaningRequests);

    useEffect(() => {
        // get id from url, ex. /order-details/2, id = 2
        const array = pathname.split('/');
        setId(array[array.length - 1]);
    }, []);

    useEffect(() => {
        const getOrderById = async () => {
            try {
                setLoading(true);
                await dispatch(cleaningRequestsActions.getById({id}));
                await dispatch(cleaningRequestsActions.getCleanerApplicationsByCleaningRequest({id}));
            } catch (error) {
                console.error("Error fetching order:", error);
                alert(error?.message);
            } finally {
                setLoading(false);
            }
        }

        const getOffersByCurrentUser = async () => {
            try {
                setLoading(true);
                await dispatch(offerActions.getAllOffersByCurrentUser());
            } catch (error) {
                console.error("Error fetching order:", error);
                alert(error?.message);
            } finally {
                setLoading(false);
            }
        }


        if (!!id) {
            getOrderById();
            getOffersByCurrentUser();
        }
    }, [dispatch, id]);

    useEffect(() => {
        orderService.getByCurrentUser()
            .then(response => {
                const data = response.data;
                setOrders(data);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                alert(error?.message);
            });
    }, []);

    useEffect(() => {
        const isOrder = orders.filter((item) => item?.offer?.cleaner_request?.pk === order?.pk);

        if (isOrder?.length > 0) {
            setIsOrder(isOrder[0]?.offer?.order);
        }
    }, [orders, order]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            dispatch(feedbackCustomerActions.clearAllData());
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [dispatch]);

    return (
        <>
            {loading ?
                <Loader/> :
                <>
                    {
                        currentStep === 'step1' &&
                        <DetailsOrderPage
                            order={order}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            isOrder={isOrder}
                        />
                    }

                    {
                        currentStep === 'step2' &&
                        <SearchCleanerPage
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            isOrder={isOrder}
                        />
                    }

                    {
                        currentStep === 'step3' &&
                        <ConfirmOrderPage
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            isOrder={isOrder}
                        />
                    }
                </>}
        </>
    );
};

export default IsCustomer(TriangleStepperPagesContainer);
